import React, { useState } from "react";
import { ArrowLeft, User } from "lucide-react";

import { cpfValido, formatarCpf } from "../pix-cobranca/lib/cpf";

// CPF igual ao totem: já cadastrado entra, novo pede só o primeiro nome.
// O CPF é o que dá nome à rodada na comanda e libera o cashback.
//
// O WhatsApp só aparece pra quem o CPF não achou, e só quando a loja liga
// "Pedir também o WhatsApp" nas Preferências. Quem já tem cadastro entra pelo
// CPF e nunca vê essa pergunta.
const formatarTelefone = (bruto) => {
  const n = String(bruto || "").replace(/\D/g, "").slice(0, 11);
  if (n.length <= 2) return n;
  if (n.length <= 7) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
  return `(${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7)}`;
};

export default function TelaIdentificacao({
  onConfirmar, onVoltar, darkMode, cashbackPct, exigeTelefone,
}) {
  const [etapa, setEtapa] = useState("cpf");
  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const fundo = darkMode ? "bg-zinc-950 text-zinc-100" : "bg-white text-zinc-900";
  const campo = `w-full h-16 rounded-2xl px-5 text-2xl font-bold tracking-wide text-center outline-none border-2 ${
    darkMode ? "bg-zinc-900 border-zinc-700 focus:border-primary" : "bg-zinc-50 border-zinc-200 focus:border-primary"
  }`;
  const digitosTelefone = telefone.replace(/\D/g, "");

  const enviar = async () => {
    setErro("");
    if (etapa === "cpf" && !cpfValido(cpf)) {
      setErro("Confira o CPF digitado.");
      return;
    }
    if (etapa === "nome") {
      if (nome.trim().length < 3) {
        setErro("Digite seu primeiro nome.");
        return;
      }
      if (exigeTelefone && digitosTelefone.length < 10) {
        setErro("Digite seu WhatsApp com DDD.");
        return;
      }
    }
    setEnviando(true);
    const resposta = await onConfirmar(
      cpf,
      etapa === "nome" ? nome.trim() : undefined,
      etapa === "nome" ? digitosTelefone : undefined,
    );
    setEnviando(false);
    if (resposta?.ok) return;
    if (resposta?.codigo === "NOME_OBRIGATORIO") {
      setEtapa("nome");
      return;
    }
    setErro(resposta?.mensagem || "Não consegui confirmar. Tente de novo.");
  };

  return (
    <div className={`fixed inset-0 z-[60] flex flex-col px-6 pt-10 ${fundo}`}>
      <button type="button" onClick={onVoltar} className="flex items-center gap-1 text-sm opacity-60 mb-8">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </button>
      <div className="w-16 h-16 rounded-2xl bg-primary/15 text-primary flex items-center justify-center mb-5">
        <User className="w-8 h-8" />
      </div>
      {etapa === "cpf" ? (
        <>
          <h2 className="text-3xl font-black leading-tight">Qual o seu CPF?</h2>
          <p className="text-sm opacity-60 mt-2 mb-6">
            É o que põe seu nome no pedido
            {cashbackPct ? ` e garante ${cashbackPct}% de cashback` : ""}.
          </p>
          <input
            className={campo}
            inputMode="numeric"
            autoComplete="off"
            placeholder="000.000.000-00"
            value={formatarCpf(cpf)}
            onChange={(e) => setCpf(e.target.value.replace(/\D/g, "").slice(0, 11))}
            data-e2e="mesa-cpf"
            autoFocus
          />
        </>
      ) : (
        <>
          <h2 className="text-3xl font-black leading-tight">Como te chamamos?</h2>
          <p className="text-sm opacity-60 mt-2 mb-6">
            {exigeTelefone
              ? "Primeiro nome e o WhatsApp, e a gente já te conhece da próxima vez."
              : "Primeiro nome já basta."}
          </p>
          <input
            className={campo}
            autoComplete="off"
            placeholder="Seu nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            data-e2e="mesa-nome"
            autoFocus
          />
          {exigeTelefone ? (
            <input
              className={`${campo} mt-3`}
              inputMode="tel"
              autoComplete="off"
              placeholder="(00) 00000-0000"
              value={telefone}
              onChange={(e) => setTelefone(formatarTelefone(e.target.value))}
              data-e2e="mesa-telefone"
            />
          ) : null}
        </>
      )}
      {erro ? <p className="text-sm text-red-500 mt-3 text-center">{erro}</p> : null}
      <button
        type="button"
        onClick={enviar}
        disabled={enviando}
        data-e2e="mesa-identificar"
        className="mt-8 w-full h-16 rounded-full bg-primary text-primary-foreground text-lg font-black active:scale-[0.98] transition disabled:opacity-60"
      >
        {enviando ? "Confirmando..." : "CONTINUAR"}
      </button>
    </div>
  );
}
